import { createPostApi } from "@api/util/createPostApi";

import type { IApiResponse } from "@api";
import type { IFileResponse } from "@interfaces";

import type { IPathBaseParam } from "./path";

const postApis = createPostApi<
  IApiResponse<IFileResponse>,
  IPathBaseParam,
  object
>("stores.warehouses.batches.exportExcel");

export const exportExcel = {
  ...postApis,
};
